import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MessageService } from '../../_services/message.service';
import { CoinConfigService } from '../../_services/coinconfig.service';
import { LineBotService } from '../../_services/line-bot.service';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

    modelBuy: any = {};
    modelSell: any = {};
    modelBuyMany: any = {};
    modelSellMany: any = {};
    messageBuy: string = '';
    messageSell: string = '';
    messageBuyMany: string = '';    
    messageSellMany: string = '';

    markets: Observable<any[]>;
    marketId: number = 2; // default BINANCE

    lineBotAlls: Observable<any[]>;
    lineBotId: number = 6; // default BITLION bot


    MESSAGE_SUCCESS = '保存成功！';
    MESSAGE_ERROR = 'データ保存が失敗しました。';
    MESSAGE_WARNING = 'メッセージ内容は[CoinName]、 [Rate]等の文字式が必要になる。';

    constructor(
        private messageService: MessageService,
        private coinConfigService: CoinConfigService,
        private lineBotService: LineBotService
    ) { }

    ngOnInit() {
        this.markets = this.coinConfigService.getMarkets();
        this.lineBotAlls = this.lineBotService.getLineBot();
        this.modelBuy.type = 1;
        this.modelSell.type = 2;
        this.modelBuyMany.type = 3;
        this.modelSellMany.type = 4;

        this.messageService.get(this.marketId, this.lineBotId).subscribe(
            data => {
                if (data.length) {
                    for (let entry of data) {
                        switch (+entry.content_type) {
                            case this.modelBuy.type:
                                this.modelBuy.message = entry.content;
                                break;
                            case this.modelSell.type:
                                this.modelSell.message = entry.content;
                                break;
                            case this.modelBuyMany.type:
                                this.modelBuyMany.message = entry.content;
                                break;
                            case this.modelSellMany.type:
                                this.modelSellMany.message = entry.content;
                                break;
                        }
                    }
                }
            }, error => {
                alert(error);
            }
        );
    }

    saveBuy() {
        this.modelBuy.market_id = +$('#market').val();
        this.modelBuy.line_bot_id = +$('#lineBot').val();
        this.messageBuy = '';
        if (this.checkFormatMessage(this.modelBuy.message)) {
            this.messageService.save(this.modelBuy).subscribe(
                data => {
                    this.messageBuy = this.MESSAGE_SUCCESS;
                }, error => {
                    this.messageBuy = this.MESSAGE_ERROR;
                }
            );
        } else {
            this.messageBuy = this.MESSAGE_WARNING;
        }

        
    }

    saveSell() {
        this.modelSell.market_id = +$('#market').val();
        this.modelSell.line_bot_id = +$('#lineBot').val();
        this.messageSell = '';
        if (this.checkFormatMessage(this.modelSell.message)) {
            this.messageService.save(this.modelSell).subscribe(
                data => {
                    this.messageSell = this.MESSAGE_SUCCESS;
                }, error => {
                    this.messageSell = this.MESSAGE_ERROR;
                }
            );
        } else {
            this.messageSell = this.MESSAGE_WARNING;
        }
    }

    saveBuyMany() {
        this.modelBuyMany.market_id = +$('#market').val();
        this.modelBuyMany.line_bot_id = +$('#lineBot').val();
        this.messageBuyMany = '';
        if (this.checkFormatMessage(this.modelBuyMany.message)) {
            this.messageService.save(this.modelBuyMany).subscribe(
                data => {
                    this.messageBuyMany = this.MESSAGE_SUCCESS;
                }, error => {
                    this.messageBuyMany = this.MESSAGE_ERROR;
                }
            );
        } else {
            this.messageBuyMany = this.MESSAGE_WARNING;
        }
    }

    saveSellMany() {
        this.modelSellMany.market_id = +$('#market').val();
        this.modelSellMany.line_bot_id = +$('#lineBot').val();
        this.messageSellMany = '';
        if (this.checkFormatMessage(this.modelSellMany.message)) {
            this.messageService.save(this.modelSellMany).subscribe(
                data => {
                    this.messageSellMany = this.MESSAGE_SUCCESS;
                }, error => {
                    this.messageSellMany = this.MESSAGE_ERROR;
                }
            );
        } else {
            this.messageSellMany = this.MESSAGE_WARNING;
        }
    }

    onChangeMarkets(event) {
        this.messageBuy = '';
        this.messageSell = '';
        this.messageBuyMany = '';
        this.messageSellMany = '';
        this.marketId = event.target.value;
        this.messageService.get(this.marketId, $('#lineBot').val()).subscribe(
            data => {
                if (data.length) {
                    for (let entry of data) {
                        switch (+entry.content_type) {
                            case this.modelBuy.type:
                                this.modelBuy.message = entry.content;
                                break;
                            case this.modelSell.type:
                                this.modelSell.message = entry.content;
                                break;
                            case this.modelBuyMany.type:
                                this.modelBuyMany.message = entry.content;
                                break;
                            case this.modelSellMany.type:
                                this.modelSellMany.message = entry.content;
                                break;
                        }
                    }
                }
            }, error => {
                alert(error);
            }
        );
    }

    onChangeLineBot(event) {
        this.messageBuy = '';
        this.messageSell = '';
        this.messageBuyMany = '';
        this.messageSellMany = '';
        this.lineBotId = event.target.value;
        this.messageService.get($('#market').val(), this.lineBotId).subscribe(
            data => {
                if (data.length) {
                    for (let entry of data) {
                        switch (+entry.content_type) {
                            case this.modelBuy.type:
                                this.modelBuy.message = entry.content;
                                break;
                            case this.modelSell.type:
                                this.modelSell.message = entry.content;
                                break;
                            case this.modelBuyMany.type:
                                this.modelBuyMany.message = entry.content;
                                break;
                            case this.modelSellMany.type:
                                this.modelSellMany.message = entry.content;
                                break;
                        }
                    }
                }
            }, error => {
                alert(error);
            }
        );
    }

    checkFormatMessage(message){
        if (message.indexOf("[CoinName]") == -1) return false;
        if (message.indexOf("[Rate]") == -1) return false;
        return true;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/message/message.component.ts